import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api/billing';
import { useAuthStore } from '../store/auth';
import { useI18n } from '../i18n';
import LocaleSwitcher from '../components/LocaleSwitcher';

export default function LoginPage() {
  const { tx } = useI18n();
  const navigate = useNavigate();
  const setAuth = useAuthStore((s) => s.setAuth);

  const [clientId, setClientId] = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { access_token, expires_in } = await login(clientId, clientSecret);
      setAuth(access_token, expires_in, clientId, clientSecret);
      navigate('/');
    } catch {
      setError(tx.login.error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="ep-page ep-page--centered">
      <header className="ep-login__header">
        <span className="ep-logo">Permio</span>
        <LocaleSwitcher />
      </header>

      <main className="ep-login__card">
        <h1 className="ep-login__title">{tx.login.title}</h1>
        <p className="ep-login__subtitle">{tx.login.subtitle}</p>

        <form onSubmit={handleSubmit} className="ep-form">
          <div className="ep-field">
            <label className="ep-label" htmlFor="clientId">
              {tx.login.clientId}
            </label>
            <input
              id="clientId"
              className="ep-input"
              type="text"
              autoComplete="username"
              spellCheck={false}
              required
              value={clientId}
              onChange={(e) => setClientId(e.target.value)}
            />
          </div>

          <div className="ep-field">
            <label className="ep-label" htmlFor="clientSecret">
              {tx.login.clientSecret}
            </label>
            <input
              id="clientSecret"
              className="ep-input"
              type="password"
              autoComplete="current-password"
              required
              value={clientSecret}
              onChange={(e) => setClientSecret(e.target.value)}
            />
          </div>

          {error && <p className="ep-error">{error}</p>}

          <button className="ep-btn ep-btn--primary" type="submit" disabled={loading}>
            {loading ? tx.login.loading : tx.login.submit}
          </button>
        </form>
      </main>
    </div>
  );
}
